export default __webpack_public_path__ + "static/media/example_csv_after.a60091b5.png";